import * as yup from 'yup';
import validate from './validate';

const minPasswordLength = 4;

const email = yup
  .string()
  .email('Form.Error.invalid-email')
  .required('Form.Error.required-field');

const optionalEmail = yup.string().email('Form.Error.invalid-email');

const username = yup.string().required('Form.Error.required-field');
// const formikText = yup.string().max(25);
const amount = yup.number('Form.Error.invalid-number').required('Form.Error.required-field');
const required = yup.string().required('Form.Error.required-field');
const numMinLength = (minLength) => yup
  .number('Form.Error.invalid-number')
  .min(minLength, 'Form.Error.invalid')
  .required('Form.Error.required-field');
// const formikDate = yup.object().required('Form.Error.required-field');
const phone = yup
  .number('Form.Error.invalid-phone')
  .min(1000000, 'Form.Error.invalid-phone')
  .max(9999999, 'Form.Error.invalid-phone')
  .required('Form.Error.required-field');
const optionalPhone = yup
  .number('Form.Error.invalid-phone')
  .min(1000000, 'Form.Error.invalid-phone')
  .max(9999999, 'Form.Error.invalid-phone');

const password = yup
  .string()
  .min(minPasswordLength, 'Form.Error.password-too-short')
  .required('Form.Error.required-field');
const loginPassword = yup.string().required('Form.Error.required-field');
const confirmPassword = yup
  .string()
  .min(minPasswordLength, 'Form.Error.password-too-short')
  .oneOf([yup.ref('newPassword')], 'Form.Error.no-match')
  .required('Form.Error.required-field');

const minLength = (length) => yup
  .string()
  .min(length, 'Form.Error.invalid')
  .required('Form.Error.required-field');

const ssn = yup
  .string('Form.Error.string-only')
  .required('Form.Error.required-field')
  .test('test-ssn', 'Form.Error.invalid-ssn', (value) => validate.ssn(value));
const optionalSsn = yup
  .string('Form.Error.string-only')
  .test('test-ssn', 'Form.Error.invalid-ssn', (value) => validate.ssn(value));
const account = yup
  .string('Form.Error.string-only')
  .required('Form.Error.required-field')
  .max(6, 'Form.Error.invalid');
const bank = yup
  .string('Form.Error.string-only')
  .required('Form.Error.required-field')
  .min(3, 'Form.Error.invalid')
  .max(4, 'Form.Error.invalid');
const ledger = yup
  .string('Form.Error.string-only')
  .required('Form.Error.required-field')
  .length(2, 'Form.Error.invalid');

const checkboxRequired = yup.bool().oneOf([true], 'Form.Error.invalid');

const formik = {
  email,
  optionalEmail,
  username,
  amount,
  required,
  numMinLength,
  minLength,
  phone,
  optionalPhone,
  password,
  loginPassword,
  confirmPassword,
  ssn,
  optionalSsn,
  account,
  bank,
  ledger,
  checkboxRequired,
};

export default formik;
